import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { threadId } from 'worker_threads';
import { HostListener } from '@angular/core';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
@Component({
  selector: 'app-customer-purchase',
  templateUrl: './customer-purchase.component.html',
  styleUrls: ['./customer-purchase.component.scss'],
})
export class CustomerPurchaseComponent {
  brand;
  option;
  area;
  capacity;
  model;
  pay;
  colour;
  type;
  size;
  info:boolean=false;
  changeView:boolean=false;
  editShow:boolean=false;
  show:boolean=true;
  fDate;
  slots;
  dateFormat;
  promotions;
  promoObj;
  couponId;
  discountCoupon;
  payTotal;
  Id;
  optionName;
  optionId;
  // minDate = new Date();
  purchasedate:any;
  loader: boolean = true;
  active: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;
  item:any;
  fontStyle;
  send:boolean=false;
  identificationNo;
  id;
  pic;
  cloneUsers:any=[];
  custName;
  category;
categoryName;
categoryId;
typeObj;
typeName;
typeId;
userId;
url;
typeObjAll;
Oid;users;
contactNbrMob;
itemCategoryId;
allServices:any=[];
services:any=[];
pacService:any=[];
serviceId;
serviceName;
startdate;
fdateCheck;
applicableDays;
applicableDaysName;
applicableDaysId;
allIndServices;
singleService;
daysObj=[{id:1,name:"Sunday"},
{id:2,name:"Monday"},
{id:3,name:"Tuesday"},
{id:4,name:"Wednesday"},
{id:5,name:"Thursday"},
{id:6,name:"Friday"},
{id:7,name:"Saturday"}];
dayType;
selectedDays:any=[];
date: any; 
buttonObj:any=[{name:"Individual House",flat:false,id:1},
{name:"Flat",flat:true,id:2}]
flatType = this.buttonObj[0].id;
appt:boolean = this.buttonObj[0].flat;
flatNo;
flatName;
custResItemObj:any=[];
custItemObj:any=[];
doorNbr;
custitem:any = [];
addItem:boolean=false;
plusBtn:boolean=true;
homeCleaning:boolean=false;
fridgeWashing:boolean=false;
acService:boolean=false;
custItemName;
subItemsType;
custItemId;
street;
subsId;
subscription;
cateId;
carService:boolean;
servId;
openItem:boolean=false;
categoryCode;
clicked:boolean=false;
head:boolean=false;
custReq:boolean=false;
addBtn:boolean=false;
serReq:boolean=false;
pricing:boolean=false;
typeCode;
itemTypeId;
minDate = new Date();
subType;
invoiceId;
time = "Time";
endTime;
availableSlots=[];
ItemsSelected:any=[];
availSlot:boolean;
slotClicked:boolean;
openSlot:boolean = false;
slot;
slotDate;
orderId;
orderItems:any;
defaultAddress;
regionchange:boolean=false;
changeDate:boolean = false;
  constructor(private service: ApiService,public handler: HandlerService,public router: Router,
    public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet,
    private loc: Geolocation,
    private platform:Platform,
    private geoCoder:NativeGeocoder) { }

  ionViewWillEnter() {
    this.Oid=localStorage.getItem('organizationId')
    this.loader=true;  
    this.url = window.location.href;
    this.id = localStorage.getItem('currentUserId');
    this.orderId = sessionStorage.getItem('orderId');
    this.categoryCode = sessionStorage.getItem('cateCode')
    this.getUsers(); 
    this.getOrder();
     }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {   
      this.router.navigate(['/bookservice1'])  
    }

    getOrder() {
      this.service.getOrderById(this.orderId).subscribe((res: any) => {
      this.orderItems = res;
      this.ItemsSelected = res.itemOrders; 
      this.location.regionId=res.delRegion,
      this.location.street=res.delStreet,
      this.location.stateId=res.delState,
      this.location.cityId=res. delCity                     
      })
    }

  

  itemCategory(){ 
    this.service.getOrgCategory().subscribe(res=>{
      this.category = res;    
        if (this.category.length > 0) {
          this.category.map(res1 => {
            if (res1.id == this.cateId ) {         
              this.categoryName = res1.name;
              this.categoryId = res1.id;
              this.categoryCode = res1.code;                                                  
            }
            }) 
      }
      this.getUsers();
     })
  }

  addCustItem(){
    if(this.custitem.length>0){
    this.custitem.map(res=>{
      if(res.clicked){
        res.clicked=false
       }
      })
    }
    this.addItem = true;
    this.custReq=false;
    this.serReq=true;
    this.custItemId = "";
  }



 savedItems(){
   this.openItem = true;
   if(this.custitem == ""){
    this.handler.res("No Saved Items For You");
   }
 }

  getUsers(){  
    this.service.getUserById(this.id).subscribe((res:any) => {    
      this.users = res; 
      this.custItemObj=this.users.custItems;   
      this.custitem=this.custItemObj.filter(res =>res.itemCategoryId ==  this.cateId && res.make != "XXX");
      this.custName = this.users.firstName;
      this.contactNbrMob = this.users.contactNbrMob;
       this.loader=false;  
       },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
   
  }

  getUsersAdrs(){  
    this.service.getUserById(this.id).subscribe((res:any) => {    
      this.users = res; 
  this.loader=false;
     
      },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
   
  }

  onInput() {
    this.location.serviceArea = true;
    this.location.autoComplete();
  }

  sendId(data,id){
    data.clicked = ! data.clicked;
    this.custitem.map(res=>{if(id!=res.id){
      res.clicked=false;
    }
    })
    this.custItemId = id;
    let x=this.custitem.find(res=>res.clicked);
    if(!x){   
      this.custItemId ="";
    }
    this.location.typeId = data.type;
    this.location.houseNbr=data.houseNbr;
    this.location.cityId=data.cityId;
    this.location.stateId=data.stateId;
    this.location.street=data.street;
    this.location.regionId=data.regionId;
    this.location.zipcode=data.zipcode;
    this.location.lat=data.lat;
    this.location.lon=data.lon;
    this.appt=data.appt;
    this.doorNbr=data.doorNbr;
    this.flatNo=data.flatNo;
    this.flatName=data.flatName;
    this.custReq=true;
    this.serReq=false;
  }

    
    UpdateService(){    
         this.loader = true;
          Object.assign(this.orderItems,{"type": 1,
          "appt":this.appt,
          "capacityDefId":  '1',
          "custName"  :this.custName,
          // "apptTime": this.time,
          "apptDate": this.fDate,
          "cnvcChargeApplied":true
        })
            if(!this.appt){
             Object.assign(this.orderItems,{"delDoorNbr":this.doorNbr,"delStreet": this.location.street,"delRegion":this.location.regionId,"delCity":this.location.cityId,"delState":this.location.stateId})
           }else{
             Object.assign(this.orderItems,{"flatNo":this.flatNo, "flatName":this.flatName,"delRegion":this.location.regionId,"delCity":this.location.cityId,"delState":this.location.stateId})
           }
        this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{   
        let url=window.location.href
           this.router.navigate(['purchase-invoice/',this.orderId])   
        this.loader = false;
      },err => {
        this.loader = false;
        this.handler.err(err)
      })
       
     }
     
    getSingleService(){
      this.service.getAllItems().subscribe((res: any) => {
     this.allServices=res;   
     if (this.allServices.length > 0) {
      this.allServices.map(res1 => {
        if (res1.id == this.servId ) {
          this.serviceName = res1.name;
          this.serviceId = res1.id;
          this.location.subscriptionId = res1.id;
        }
        }) 
  }
    
    })
 }

 cancel(){
    this.router.navigate(['/bookservice1' ])
 }

 getAppt(id){
  this.appt = id;
} 
   
  
    ionViewWillLeave(){
      this.brand="";
      this.model="";
      this.custName="";
      this.contactNbrMob="";
      this.categoryName="";
      this.typeName="";
      this.typeId="";
      this.categoryId="";
      this.serviceName="";
      this.identificationNo="";      
      this.location.markedPrice="";
      this.location.typeId="";
      this.location.subscriptionId = "";
      this.location.pop=false;
      this.location.newSearch="";                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
      sessionStorage.removeItem('cateId')  
      sessionStorage.removeItem('itemType')
      sessionStorage.removeItem('itemId')
      this.regionchange = false;
      this.changeView = false;
      this.time="";
      this.dateFormat="";
      this.colour="";
    }

    userDetails(data){
      this.contactNbrMob =data.contactNbrMob;
      // this.userId = data.userId;
   
    }


  //  getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    // openBottomSheet(): void {
    //   if(this.custItemId==null){
    //   const dialogRef = this.bottomSheet.open(BottomSheet,{
    //     data: this.category,
    //   });
    //   dialogRef.afterDismissed().subscribe((res:any) => {
    //     if(res){
    //       this.categoryName = res.name;
    //       this.categoryId=res.id;  
    //       if(this.url.includes("single-request") || this.url.includes('single-requests') || this.url.includes('req-booking')){
    //         this.custitem=this.custItemObj.filter(res =>res.itemCategoryId == this.categoryId);
    //         this.custitem.every(res=>Object.assign(res,{clicked:false}));
    //         this.head=true;  
    //         this.addBtn=true;
    //        }    
          
    //       }     
        
    //   });
    // }
    // }

    // openBottomSheet1(): void {
    //   if(this.categoryCode=="CAR"){
    //     this.typeObj=this.typeObjAll.filter(res=> res.itemCategory==this.cateId)   
    //     const dialogRef = this.bottomSheet.open(BottomSheet,{
    //       data: this.typeObj,
    //     });
    //     dialogRef.afterDismissed().subscribe((res:any) => {
    //       if(res){
    //         this.typeName = res.name;
    //         this.typeId=res.id;
    //         this.location.typeId=res.id;
    //         if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
    //           this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
    //             var data={
    //               "itemTypeId": this.location.typeId,
    //               "region": this.location.regionId,
    //               "serviceId":this.location.subscriptionId 
    //             }
    //             this.service.getCost(data).subscribe((res:any)=>{
    //               if(res!=null){
    //                 this.location.markedPrice = res[0].cost;
    //               }else{
    //                 this.handler.error("Please Select Different Location");
    //                 this.location.markedPrice = "";
    //               }
    //             }, err => {
    //               this.handler.err(err);
    //             })
    //         }
    //       }
    //     });
      
    //   } 
     
    // }

    switchDayType(val){
      let a=this.selectedDays.filter(res=>res.id==val);
      if(a.length>0){
        var b = a[0].id
      }
      if(b==undefined){
        let check=this.daysObj.find(res=>{return res.id==val})
        if(check){
          this.selectedDays.push({id:check.id,name:check.name})
        }
      }else{
        this.handler.res("Day Already Added")
      }
    }


    removeChip(i) {
      this.selectedDays.splice(i, 1);
    }


    
    handleFile(files) {
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data) => {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.pic = canvas.toDataURL('image/jpeg', 1.5);
        }
    }

    returnDate(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();  
     return year + '-' + month + '-' + date;
   }

   returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();  
   return date + '-' + month + '-' + year;
 }

   startDate(){
      this.fDate=this.returnDate(this.startdate);
      this.slotDate=this.returnDate1(this.startdate);
      this.time = "Time"
    }

    checkPreview(){
      this.openSlot = true;
      this.slotClicked =false;
      var post ={
        "targetCenterId": this.Oid,
        "targetSource": this.Oid,
        "schElements": [
            1
        ],
        "requestDate": this.fDate,
        "status": [
            "SlotsAvailable"
        ],
        "independentEntities": true,
        "slotDuration": 15
    }
      this.service.getTimeSlots(this.slotDate,post).subscribe((res: any) => {
        if (res){
          this.availableSlots = res;
          this.availSlot = true;
          this.slotClicked = true;
        }else{
           this.handler.res("No Available Slots");
           this.availSlot = false;
           this.slotClicked = true;
        }
        
      })
    }


    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
      this.regionchange = false;
    }

    locationpop(){
      this.location.openPop();
      this.regionchange = true;
      this.getUsersAdrs();
    }
   
    open(){
      this.addItem=true;
      this.plusBtn = false;
    }

    close(){
      this.addItem=false;
      this.plusBtn = true;  
    }
      
  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.setLoc();  
    this.location.pop = false;
  }

  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             this.location.cityId=loc[0].locality;    
             this.location.regionId=loc[0].subLocality;       
        })        
    })
this.location.serviceArea = true;

 }   
}
}